import api from '../services/api';
import { IPaymentMethod } from '../shared/interfaces';

interface IResponseGetPaymentMethods {
  data: IPaymentMethod[];
  count: number;
}
export const getPaymentsMethods = async (
  take: number,
  skip: number,
  keyword?: string,
): Promise<IResponseGetPaymentMethods> => {
  const response = await api.post('/payments-methods/list', {
    take,
    skip,
    keyword,
  });
  return response.data;
};

export const postPaymentMethod = async (
  payload: any,
): Promise<IPaymentMethod> => {
  const response = await api.post(`/payments-methods`, payload);
  return response.data;
};

export const patchPaymentMethod = async (
  id: string | undefined,
  payload: any,
): Promise<IPaymentMethod> => {
  if (!id) {
    throw new Error('ID do forma de pagamento não fornecido.');
  }
  const response = await api.patch(`/payments-methods/${id}`, payload);
  return response.data;
};

export const getSelectPaymentsMethods = async (): Promise<IPaymentMethod[]> => {
  const response = await api.get(`/payments-methods/select/all`);
  return response.data;
};
